module.exports = require("./zh-Hant.d.ts");